/**
 * @file Who may open the Groups page: the route guard, both sidebars and the Templates pages' links
 * into Groups read this one list, so a role can never see a link the router then refuses.
 */
export const GROUP_ROLES = ['super_admin', 'admin']

/** The same test as AuthMixin.hasPermission, for components that do not use the mixin. */
export function canManageGroups(roles?: string[] | null): boolean {
  return GROUP_ROLES.some(role => roles?.includes(role))
}
